import { ChecksumAddress } from "./checksum-address";
import * as t from "io-ts";
import { BigIntFromString } from "io-ts-types";
import { PositionTypeLegacy } from "./position";
import { Schema } from "@effect/schema";
import { Address } from "./address";
import { Percent } from "./percent";

/**
 * @deprecated use `MerklReward` instead
 */
export const MerklRewardLegacy = t.type({
  tokenAddress: ChecksumAddress,
  symbol: t.string,
  apr: BigIntFromString,
  type: PositionTypeLegacy,
  isSuperfest: t.boolean,
});

export type MerklRewardLegacy = t.TypeOf<typeof MerklRewardLegacy>;
export type EncodedMerklRewardLegacy = t.OutputOf<typeof MerklRewardLegacy>;

export const LendingMerklRewardLegacy = t.type({
  targetTokenAddress: ChecksumAddress,
  targetTokenSymbol: t.string,
  rewardTokenAddress: ChecksumAddress,
  rewardTokenSymbol: t.string,
  rewardTokenDecimals: t.number,
  rewardTokenPriceUsd: BigIntFromString,
  merklApr: t.union([BigIntFromString, t.null]),
  calculatedApr: BigIntFromString,
  apr: BigIntFromString,
  isSuperFest: t.boolean,
  positionType: PositionTypeLegacy,
  amountPerSecond: BigIntFromString,
  totalTokens: BigIntFromString,

  // these are just here for interop
  tokenAddress: ChecksumAddress,
  symbol: t.string,
  type: PositionTypeLegacy,
  isSuperfest: t.boolean,
});

export type LendingMerklRewardLegacy = t.TypeOf<
  typeof LendingMerklRewardLegacy
>;
export type EncodedLendingMerklRewardLegacy = t.OutputOf<
  typeof LendingMerklRewardLegacy
>;

export type BaseMerklReward = typeof BaseMerklReward.Type;
export type BaseMerklRewardEncoded = typeof BaseMerklReward.Encoded;

export const BaseMerklReward = Schema.Struct({
  targetTokenAddress: Address,
  targetTokenSymbol: Schema.String,
  rewardTokenAddress: Address,
  rewardTokenSymbol: Schema.String,
  merklApr: Schema.NullOr(Percent),
  calculatedApr: Percent,
  apr: Percent,
  isSuperFest: Schema.Boolean,
});

export type CollateralMerklReward = typeof CollateralMerklReward.Type;
export type CollateralMerklRewardEncoded = typeof CollateralMerklReward.Encoded;

export const CollateralMerklReward = Schema.Struct({
  positionType: Schema.tag("collateral"),
  ...BaseMerklReward.fields,
}).annotations({ identifier: "CollateralMerklReward" });

export type ProtectedMerklReward = typeof ProtectedMerklReward.Type;
export type ProtectedMerklRewardEncoded = typeof ProtectedMerklReward.Encoded;

export const ProtectedMerklReward = Schema.Struct({
  positionType: Schema.tag("protected"),
  ...BaseMerklReward.fields,
}).annotations({ identifier: "ProtectedMerklReward" });

export type DebtMerklReward = typeof DebtMerklReward.Type;
export type DebtMerklRewardEncoded = typeof DebtMerklReward.Encoded;

export const DebtMerklReward = Schema.Struct({
  positionType: Schema.tag("debt"),
  ...BaseMerklReward.fields,
}).annotations({ identifier: "DebtMerklReward" });

export type MerklReward = typeof MerklReward.Type;
export type MerklRewardEncoded = typeof MerklReward.Encoded;

export const MerklReward = Schema.Union(
  CollateralMerklReward,
  ProtectedMerklReward,
  DebtMerklReward
).annotations({ identifier: "MerklReward" });
